import * as Models from '@module/shared/components/Site/models';
import * as actionCreators from './actionCreators/registerSiteActionCreators';

export const initialSitesState: Models.ISitesState = {
    sites: [],
    sitesLoading: false,
    pagingSettings: {
        skipItems: 0,
        pageSize: 20
    },
    sortingSettings: {
        sortDirection: 'asc',
        sortField: 'SiteName'
    },
    totalNumberOfSites: 0,
    searchFilter: '',
    siteSelected: false,
    selectedSite: Models.defaultSite,
    selectedSiteRegistered: false,
    siteRegister: {
        attempt: false,
        success: false,
        siteId: -1
    },
    fromServIs: true
};

export function registerSiteReducer(state = initialSitesState, action: any): any {
    switch (action.type) {
        case actionCreators.SERVIS_SITE_GET_REQUEST:
            return {
                ...state,
                sites: [],
                sitesLoading: true
            };
        case actionCreators.SERVIS_SITE_GET_SUCCESS:
            return {
                ...state,
                sites: action.sites,
                totalNumberOfSites: action.totalNumberOfSites,
                sitesLoading: false
            };
        case actionCreators.SERVIS_SITE_GET_ERROR:
            return {
                ...state,
                text: action.text,
                sitesLoading: false
            };
        case actionCreators.SERVIS_SITE_PAGING_CHANGE:
            return {
                ...state,
                pagingSettings: action.pagingSettings,
                sortingSettings: action.sortingSettings,
            };
        case actionCreators.SERVIS_SITE_SORT_CHANGE:
            return {
                ...state,
                pagingSettings: action.pagingSettings,
                sortingSettings: action.sortingSettings,
            };
        case actionCreators.SITE_APPLY_SEARCH:
            return {
                ...state,
                searchFilter: action.searchFilter,
                pagingSettings:  {
                    skipItems: 0,
                    pageSize: 20
                }
            };
        case actionCreators.SITE_SEARCH_CHANGE:
            return {
                ...state,
                searchFilter: action.searchFilter
            };
        case actionCreators.REGISTERED_NEW_SITE_SELECTED:
            return {
                ...state,
                siteSelected: action.siteSelected,
                selectedSite: action.selectedSite,
                registeredSiteSelected: action.selectedSite.registered
            };
        case actionCreators.SERVIS_SITE_REGISTER_SUCCESS:
            return {
                ...state,
                siteRegister: {
                    attempt: true,
                    success: true,
                    siteId: action.site.siteId
                }
            };
        case actionCreators.SERVIS_SITE_REGISTER_ERROR:
            return {
                ...state,
                siteRegister: {
                    attempt: true,
                    success: false
                }
            };
        case actionCreators.SERVIS_SITE_PAGE_LEAVE:
            return {
                ...state,
                siteSelected: false,
                selectedSite: Models.defaultSite,
                siteRegister: {
                    attempt: false,
                    success: false,
                    siteId: -1
                }
            };
        default:
            return state;
    }
}
